export function ifNotDefaultFactory(viewProperty) {
  return function ifNotDefault(key, value, defaultValue) {
    if (typeof value === 'undefined' || value === defaultValue) {
      return;
    }
    viewProperty[key] = value;
  };
}
